import React from 'react';
import { DataGridExportButton, DataGridPremium } from '@clatter/ui';
import { formatDateTime } from '@clatter/platform';

export const getColumns = ({ extraColumns }) => [
  {
    headerName: 'Creator',
    field: 'created_by',
    valueGetter: (value, row) => {
      if (!row?.created_by) {
        return null;
      }
      return `${row?.created_by?.first_name} ${row?.created_by?.last_name}`;
    },
    valueFormatter: (value) => value || 'N/A',
    sortable: true,
    flex: 1,
  },
  {
    headerName: 'Date Created',
    field: 'created_at',
    valueGetter: (value, row) => row?.created_at,
    valueFormatter: (value) => formatDateTime(value),
    sortable: true,
    flex: 1,
  },
  {
    headerName: 'Site',
    field: 'site',
    sortable: true,
    flex: 1,
  },
  {
    headerName: 'Pages',
    field: 'pages',
    valueGetter: (value, row) => row?.pages?.length,
    sortable: true,
    flex: 1,
  },
  {
    headerName: 'Published',
    field: 'published',
    valueGetter: (value, row) => row?.published,
    valueFormatter: (value) => (value ? 'Yes' : 'No'),
    sortable: true,
    flex: 1,
  },
  ...extraColumns,
];

const MicrositesDetailSiteTable = ({
  extraColumns = [],
  isLoading = false,
  rows = [],
  exportFileName,
  name = "report/msm-microsites-detail-site"
}) => (
  <DataGridPremium
    showVerticalSidebar
    loading={isLoading}
    dataGridProps={{
      getRowClassName: (params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd',
    }}
    renderCustomToolbar={() => <DataGridExportButton exportFileName={exportFileName} />}
    name={name}
    columns={getColumns({ extraColumns })}
    defaultSortField={{ field: 'created_at', sort: 'desc' }}
    rows={rows}
    getRowId={(row) => row.uuid}
    disableColumnFilter
    disablePersist
  />
);

export default MicrositesDetailSiteTable;
